const lineup = 
  {
  "anaheim-ducks": {
    forwards: {
      line1: [
        "Chris Kreider",
        "Leo Carlsson",
        "Troy Terry"
      ],
      line2: [
        "Alex Killorn",
        "Mikael Granlund",
        "Beckett Sennecke"
      ],
      line3: [
        "Jeffrey Viel",
        "Mason McTavish",
        "Cutter Gauthier"
      ],
      line4: [
        "Tim Washe",
        "Ryan Poehling",
        "Ian Moore"
      ]
    },
    defense: {
      line1: [
        "Jackson Lacombe",
        "Jacob Trouba"
      ],
      line2: [
        "Pavel Mintyukov",
        "John Carlson"
      ],
      line3: [
        "Tyson Hinds",
        "Radko Gudas"
      ]
    },
    goalies: {
      line1: [
        "Lukas Dostal",
        "Ville Husso"
      ]
    }
  },
  "boston-bruins": {
    forwards: {
      line1: [
        "Morgan Geekie",
        "Elias Lindholm",
        "David Pastrnak"
      ],
      line2: [
        "Lukas Reichel",
        "Casey Mittelstadt",
        "Michael Eyssimont"
      ],
      line3: [
        "James Hagens",
        "Fraser Minten",
        "Marat Khusnutdinov"
      ],
      line4: [
        "Alexander Steeves",
        "Sean Kuraly",
        "Mark Kastelic"
      ]
    },
    defense: {
      line1: [
        "Jonathan Aspirot",
        "Jordan Harris"
      ],
      line2: [
        "Andrew Peeke",
        "Mason Lohrei"
      ],
      line3: [
        "Nikita Zadorov",
        "Henri Jokiharju"
      ]
    },
    goalies: {
      line1: [
        "Joonas Korpisalo",
        "Jeremy Swayman"
      ]
    }
  },
  "buffalo-sabres": {
    forwards: {
      line1: [
        "Peyton Krebs",
        "Tage Thompson",
        "Alex Tuch"
      ],
      line2: [
        "Jason Zucker",
        "Ryan McLeod",
        "Jack Quinn"
      ],
      line3: [
        "Zach Benson",
        "Josh Norris",
        "Josh Doan"
      ],
      line4: [
        "Jordan Greenway",
        "Tyson Kozak",
        "Beck Malenstyn"
      ]
    },
    defense: {
      line1: [
        "Rasmus Dahlin",
        "Mattias Samuelsson"
      ],
      line2: [
        "Bowen Byram",
        "Owen Power"
      ],
      line3: [
        "Logan Stanley",
        "Zach Metsa"
      ]
    },
    goalies: {
      line1: [
        "Ukko-Pekka Luukkonen",
        "Colten Ellis"
      ]
    }
  },
  "calgary-flames": {
    forwards: {
      line1: [
        "Joel Farabee",
        "Mikael Backlund",
        "Blake Coleman"
      ],
      line2: [
        "Victor Olofsson",
        "Morgan Frost",
        "Matt Coronato"
      ],
      line3: [
        "Connor Zary",
        "Ryan Strome",
        "Adam Klapka"
      ],
      line4: [
        "Aydar Suniev",
        "Tyson Gross",
        "Yegor Sharangovich"
      ]
    },
    defense: {
      line1: [
        "Zayne Parekh",
        "Zach Whitecloud"
      ],
      line2: [
        "Olli Maatta",
        "Hunter Brzustewicz"
      ],
      line3: [
        "Abram Wiebe",
        "Brayden Pachal"
      ]
    },
    goalies: {
      line1: [
        "Dustin Wolf",
        "Devin Cooley"
      ]
    }
  },
  "carolina-hurricanes": {
    forwards: {
      line1: [
        "Andrei Svechnikov",
        "Sebastian Aho",
        "Seth Jarvis"
      ],
      line2: [
        "Nikolaj Ehlers",
        "Jordan Staal",
        "Jordan Martinook"
      ],
      line3: [
        "Nicolas Deslauriers",
        "Jesperi Kotkaniemi",
        "Eric Robinson"
      ],
      line4: [
        "Josiah Slavin",
        "Skyler Brind'Amour",
        "Bradly Nadeau"
      ]
    },
    defense: {
      line1: [
        "Josiah Slavin",
        "Shayne Gostisbehere"
      ],
      line2: [
        "Alexander Nikishin",
        "Sean Walker"
      ],
      line3: [
        "Mike Reilly",
        "Charles-Alexis Legault"
      ]
    },
    goalies: {
      line1: [
        "Brandon Bussi",
        "Frederik Andersen"
      ]
    }
  },
  "chicago-blackhawks": {
    forwards: {
      line1: [
        "Ryan Greene",
        "Connor Bedard",
        "Nick Lardis"
      ],
      line2: [
        "Tyler Bertuzzi",
        "Anton Frondell",
        "Ilya Mikheyev"
      ],
      line3: [
        "Ryan Donato",
        "Frank Nazar",
        "Andre Burakovsky"
      ],
      line4: [
        "Andrew Mangiapane",
        "Sacha Boisvert",
        "Teuvo Teravainen"
      ]
    },
    defense: {
      line1: [
        "Alex Vlasic",
        "Louis Crevier"
      ],
      line2: [
        "Wyatt Kaiser",
        "Sam Rinzel"
      ],
      line3: [
        "Kevin Korchinski",
        "Sam Lafferty"
      ]
    },
    goalies: {
      line1: [
        "Arvid Soderblom",
        "Spencer Knight"
      ]
    }
  },
  "colorado-avalanche": {
    forwards: {
      line1: [
        "Artturi Lehkonen",
        "Nathan MacKinnon",
        "Gabriel Landeskog"
      ],
      line2: [
        "Valeri Nichushkin",
        "Brock Nelson",
        "Martin Necas"
      ],
      line3: [
        "Ross Colton",
        "Nicolas Roy",
        "Joel Kiviranta"
      ],
      line4: [
        "Parker Kelly",
        "Jack Drury",
        "Logan O'Connor"
      ]
    },
    defense: {
      line1: [
        "Devon Toews",
        "Sam Malinski"
      ],
      line2: [
        "Brett Kulak",
        "Josh Manson"
      ],
      line3: [
        "Nick Blankenburg",
        "Brent Burns"
      ]
    },
    goalies: {
      line1: [
        "Scott Wedgewood",
        "Mackenzie Blackwood"
      ]
    }
  },
  "columbus-blue-jackets": {
    forwards: {
      line1: [
        "Kirill Marchenko",
        "Adam Fantilli",
        "Isac Lundestrom"
      ],
      line2: [
        "Cole Sillinger",
        "Charlie Coyle",
        "Conor Garland"
      ],
      line3: [
        "Mason Marchment",
        "Boone Jenner",
        "Danton Heinen"
      ],
      line4: [
        "Miles Wood",
        "Sean Monahan",
        "Kent Johnson"
      ]
    },
    defense: {
      line1: [
        "Zach Werenski",
        "Dante Fabbro"
      ],
      line2: [
        "Ivan Provorov",
        "Denton Mateychuk"
      ],
      line3: [
        "Egor Zamula",
        "Erik Gudbranson"
      ]
    },
    goalies: {
      line1: [
        "Jet Greaves",
        "Elvis Merzlikins"
      ]
    }
  },
  "dallas-stars": {
    forwards: {
      line1: [
        "Justin Hryckowian",
        "Wyatt Johnston",
        "Mikko Rantanen"
      ],
      line2: [
        "Jason Robertson",
        "Matt Duchene",
        "Mavrik Bourque"
      ],
      line3: [
        "Adam Erne",
        "Arttu Hyry",
        "Jamie Benn"
      ],
      line4: [
        "Cameron Hughes",
        "Oskar Back",
        "Colin Blackwell"
      ]
    },
    defense: {
      line1: [
        "Esa Lindell",
        "Ilya Lyubushkin"
      ],
      line2: [
        "Thomas Harley",
        "Tyler Myers"
      ],
      line3: [
        "Lian Bichsel",
        "Alex Petrovic"
      ]
    },
    goalies: {
      line1: [
        "Jake Oettinger",
        "Casey DeSmith"
      ]
    }
  },
  "detroit-red-wings": {
    forwards: {
      line1: [
        "Emmitt Finnie",
        "Dylan Larkin",
        "Lucas Raymond"
      ],
      line2: [
        "Alex DeBrincat",
        "Andrew Copp",
        "Patrick Kane"
      ],
      line3: [
        "Carter Mazur",
        "J.T. Compher",
        "David Perron"
      ],
      line4: [
        "James van Riemsdyk",
        "Marco Kasper",
        "Dominik Shine"
      ]
    },
    defense: {
      line1: [
        "Simon Edvinsson",
        "Moritz Seider"
      ],
      line2: [
        "Ben Chiarot",
        "Justin Faulk"
      ],
      line3: [
        "Albert Johansson",
        "Jacob Bernard-Docker"
      ]
    },
    goalies: {
      line1: [
        "John Gibson",
        "Cam Talbot"
      ]
    }
  },
  "edmonton-oilers": {
    forwards: {
      line1: [
        "Vasily Podkolzin",
        "Connor McDavid",
        "Matthew Savoie"
      ],
      line2: [
        "Max Jones",
        "Ryan Nugent-Hopkins",
        "Kasperi Kapanen"
      ],
      line3: [
        "Colton Dach",
        "Josh Samanski",
        "Trent Frederic"
      ],
      line4: [
        "Curtis Lazar",
        "Adam Henrique",
        "Jack Roslovic"
      ]
    },
    defense: {
      line1: [
        "Mattias Ekholm",
        "Evan Bouchard"
      ],
      line2: [
        "Darnell Nurse",
        "Connor Murphy"
      ],
      line3: [
        "Jake Walman",
        "Ty Emberson"
      ]
    },
    goalies: {
      line1: [
        "Connor Ingram",
        "Tristan Jarry"
      ]
    }
  },
  "florida-panthers": {
    forwards: {
      line1: [
        "Mackie Samoskevich",
        "Eetu Luostarinen",
        "A.J. Greer"
      ],
      line2: [
        "Wilmer Skoog",
        "Cole Schwindt",
        "Jesper Boqvist"
      ],
      line3: [
        "Nolan Foote",
        "Tomas Nosek",
        "Noah Gregor"
      ],
      line4: [
        "Cole Reinhardt",
        "Luke Kunin",
        "Vinnie Hinostroza"
      ]
    },
    defense: {
      line1: [
        "Gustav Forsling",
        "Michael Benning"
      ],
      line2: [
        "Donovan Sebrango",
        "Marek Alscher"
      ],
      line3: [
        "Tobias Bjornfot",
        "Ludvig Jansson"
      ]
    },
    goalies: {
      line1: [
        "Daniil Tarasov",
        "Sergei Bobrovsky"
      ]
    }
  },
  "los-angeles-kings": {
    forwards: {
      line1: [
        "Artemi Panarin",
        "Anze Kopitar",
        "Adrian Kempe"
      ],
      line2: [
        "Trevor Moore",
        "Quinton Byfield",
        "Alex Laferriere"
      ],
      line3: [
        "Joel Armia",
        "Scott Laughton",
        "Jared Wright"
      ],
      line4: [
        "Mathieu Joseph",
        "Samuel Helenius",
        "Taylor Ward"
      ]
    },
    defense: {
      line1: [
        "Mikey Anderson",
        "Drew Doughty"
      ],
      line2: [
        "Joel Edmundson",
        "Brandt Clarke"
      ],
      line3: [
        "Brian Dumoulin",
        "Cody Ceci"
      ]
    },
    goalies: {
      line1: [
        "Anton Forsberg",
        "Darcy Kuemper"
      ]
    }
  },
  "minnesota-wild": {
    forwards: {
      line1: [
        "Kirill Kaprizov",
        "Ryan Hartman",
        "Vladimir Tarasenko"
      ],
      line2: [
        "Marcus Johansson",
        "Danila Yurov",
        "Matt Boldy"
      ],
      line3: [
        "Yakov Trenin",
        "Michael McCarron",
        "Bobby Brink"
      ],
      line4: [
        "Marcus Foligno",
        "Nick Foligno",
        "Nico Sturm"
      ]
    },
    defense: {
      line1: [
        "Quinn Hughes",
        "Brock Faber"
      ],
      line2: [
        "Jacob Middleton",
        "Jonas Brodin"
      ],
      line3: [
        "Daemon Hunt",
        "Jeff Petry"
      ]
    },
    goalies: {
      line1: [
        "Jesper Wallstedt",
        "Filip Gustavsson"
      ]
    }
  },
  "montreal-canadiens": {
    forwards: {
      line1: [
        "Cole Caufield",
        "Nick Suzuki",
        "Juraj Slafkovsky"
      ],
      line2: [
        "Alexandre Texier",
        "Alex Newhook",
        "Ivan Demidov"
      ],
      line3: [
        "Oliver Kapanen",
        "Zack Bolduc",
        "Kirby Dach"
      ],
      line4: [
        "Jake Evans",
        "Phillip Danault",
        "Josh Anderson"
      ]
    },
    defense: {
      line1: [
        "Mike Matheson",
        "Kaiden Guhle"
      ],
      line2: [
        "Jayden Struble",
        "Lane Hutson"
      ],
      line3: [
        "David Reinbacher",
        "Arber Xhekaj"
      ]
    },
    goalies: {
      line1: [
        "Jacob Fowler",
        "Jakub Dobes"
      ]
    }
  },
  "nashville-predators": {
    forwards: {
      line1: [
        "Steven Stamkos",
        "Ryan O'Reilly",
        "Luke Evangelista"
      ],
      line2: [
        "Filip Forsberg",
        "Matthew Wood",
        "Jonathan Marchessault"
      ],
      line3: [
        "Zachary L'Heureux",
        "Erik Haula",
        "Joakim Kemell"
      ],
      line4: [
        "Reid Schaefer",
        "Fedor Svechkov",
        "Tyson Jost"
      ]
    },
    defense: {
      line1: [
        "Roman Josi",
        "Brady Skjei"
      ],
      line2: [
        "Adam Wilsby",
        "Justin Barron"
      ],
      line3: [
        "Ryan Ufko",
        "Nick Perbix"
      ]
    },
    goalies: {
      line1: [
        "Justus Annunen",
        "Juuse Saros"
      ]
    }
  },
  "new-jersey-devils": {
    forwards: {
      line1: [
        "Timo Meier",
        "Nico Hischier",
        "Dawson Mercer"
      ],
      line2: [
        "Jesper Bratt",
        "Jack Hughes",
        "Connor Brown"
      ],
      line3: [
        "Lenni Hameenaho",
        "Cody Glass",
        "Nick Bjugstad"
      ],
      line4: [
        "Paul Cotter",
        "Marc McLaughlin",
        "Brian Halonen"
      ]
    },
    defense: {
      line1: [
        "Jonas Siegenthaler",
        "Dougie Hamilton"
      ],
      line2: [
        "Brenden Dillon",
        "Simon Nemec"
      ],
      line3: [
        "Topias Vilen",
        "Johnathan Kovacevic"
      ]
    },
    goalies: {
      line1: [
        "Jake Allen",
        "Nico Daws"
      ]
    }
  },
  "new-york-islanders": {
    forwards: {
      line1: [
        "Anders Lee",
        "Bo Horvat",
        "Simon Holmstrom"
      ],
      line2: [
        "Brayden Schenn",
        "Mathew Barzal",
        "Calum Ritchie"
      ],
      line3: [
        "Anthony Duclair",
        "Jean-Gabriel Pageau",
        "Emil Heineman"
      ],
      line4: [
        "Kyle MacLean",
        "Casey Cizikas",
        "Marc Gatcomb"
      ]
    },
    defense: {
      line1: [
        "Matthew Schaefer",
        "Ryan Pulock"
      ],
      line2: [
        "Adam Pelech",
        "Tony DeAngelo"
      ],
      line3: [
        "Carson Soucy",
        "Scott Mayfield"
      ]
    },
    goalies: {
      line1: [
        "Ilya Sorokin",
        "David Rittich"
      ]
    }
  },
  "new-york-rangers": {
    forwards: {
      line1: [
        "Gabriel Perreault",
        "Mika Zibanejad",
        "Alexis Lafrenière"
      ],
      line2: [
        "Tye Kartye",
        "J.T. Miller",
        "Conor Sheary"
      ],
      line3: [
        "Will Cuylle",
        "Vincent Trocheck",
        "Jonny Brodzinski"
      ],
      line4: [
        "Adam Sykora",
        "Noah Laba",
        "Jaroslav Chmelar"
      ]
    },
    defense: {
      line1: [
        "Vladislav Gavrikov",
        "Adam Fox"
      ],
      line2: [
        "Urho Vaakanainen",
        "Braden Schneider"
      ],
      line3: [
        "Matthew Robertson",
        "Will Borgen"
      ]
    },
    goalies: {
      line1: [
        "Igor Shesterkin",
        "Jonathan Quick"
      ]
    }
  },
  "ottawa-senators": {
    forwards: {
      line1: [
        "Drake Batherson",
        "Stephen Halliday",
        "Claude Giroux"
      ],
      line2: [
        "Kurtis MacDermid",
        "Dylan Cozens",
        "Ridly Greig"
      ],
      line3: [
        "Nick Cousins",
        "Shane Pinto",
        "Michael Amadio"
      ],
      line4: [
        "Warren Foegele",
        "Lars Eller",
        "Fabian Zetterlund"
      ]
    },
    defense: {
      line1: [
        "Jordan Spence",
        "Artem Zub"
      ],
      line2: [
        "Dennis Gilbert",
        "Nikolas Matinpalo"
      ],
      line3: [
        "Lassi Thomson",
        "Cameron Crotty"
      ]
    },
    goalies: {
      line1: [
        "James Reimer",
        "Linus Ullmark"
      ]
    }
  },
  "philadelphia-flyers": {
    forwards: {
      line1: [
        "Tyson Foerster",
        "Trevor Zegras",
        "Owen Tippett"
      ],
      line2: [
        "Travis Konecny",
        "Christian Dvorak",
        "Porter Martone"
      ],
      line3: [
        "Denver Barkey",
        "Noah Cates",
        "Matvei Michkov"
      ],
      line4: [
        "Garnet Hathaway",
        "Sean Couturier",
        "Luke Glendening"
      ]
    },
    defense: {
      line1: [
        "Travis Sanheim",
        "Rasmus Ristolainen"
      ],
      line2: [
        "Cam York",
        "Jamie Drysdale"
      ],
      line3: [
        "Nick Seeler",
        "Emil Andrae"
      ]
    },
    goalies: {
      line1: [
        "Dan Vladar",
        "Samuel Ersson"
      ]
    }
  },
  "pittsburgh-penguins": {
    forwards: {
      line1: [
        "Egor Chinakhov",
        "Sidney Crosby",
        "Bryan Rust"
      ],
      line2: [
        "Tommy Novak",
        "Rickard Rakell",
        "Evgeni Malkin"
      ],
      line3: [
        "Ville Koivunen",
        "Kevin Hayes",
        "Justin Brazeau"
      ],
      line4: [
        "Elmer Soderblom",
        "Joona Koppanen",
        "Rutger McGroarty"
      ]
    },
    defense: {
      line1: [
        "Parker Wotherspoon",
        "Erik Karlsson"
      ],
      line2: [
        "Samuel Girard",
        "Kris Letang"
      ],
      line3: [
        "Jack St. Ivany",
        "Ilya Solovyov"
      ]
    },
    goalies: {
      line1: [
        "Stuart Skinner",
        "Arturs Silovs"
      ]
    }
  },
  "san-jose-sharks": {
    forwards: {
      line1: [
        "Igor Chernyshov",
        "Macklin Celebrini",
        "Will Smith"
      ],
      line2: [
        "William Eklund",
        "Alexander Wennberg",
        "Kiefer Sherwood"
      ],
      line3: [
        "Collin Graf",
        "Michael Misa",
        "Tyler Toffoli"
      ],
      line4: [
        "Barclay Goodrow",
        "Zack Ostapchuk",
        "Adam Gaudette"
      ]
    },
    defense: {
      line1: [
        "Dmitry Orlov",
        "Vincent Desharnais"
      ],
      line2: [
        "Mario Ferraro",
        "Shakir Mukhamadullin"
      ],
      line3: [
        "Sam Dickinson",
        "Nick Leddy"
      ]
    },
    goalies: {
      line1: [
        "Yaroslav Askarov",
        "Alex Nedeljkovic"
      ]
    }
  },
  "seattle-kraken": {
    forwards: {
      line1: [
        "Bobby McMann",
        "Matty Beniers",
        "Jordan Eberle"
      ],
      line2: [
        "Jaden Schwartz",
        "Chandler Stephenson",
        "Eeli Tolvanen"
      ],
      line3: [
        "Jared McCann",
        "Frederick Gaudreau",
        "Kaapo Kakko"
      ],
      line4: [
        "Berkly Catton",
        "Oscar Fisker Mølgaard",
        "Ryan Winterton"
      ]
    },
    defense: {
      line1: [
        "Vince Dunn",
        "Adam Larsson"
      ],
      line2: [
        "Ryan Lindgren",
        "Brandon Montour"
      ],
      line3: [
        "Ryker Evans",
        "Jamie Oleksiak"
      ]
    },
    goalies: {
      line1: [
        "Nikke Kokko",
        "Victor Ostman"
      ]
    }
  },
  "st-louis-blues": {
    forwards: {
      line1: [
        "Dylan Holloway",
        "Robert Thomas",
        "Jimmy Snuggerud"
      ],
      line2: [
        "Otto Stenberg",
        "Pavel Buchnevich",
        "Jordan Kyrou"
      ],
      line3: [
        "Jake Neighbours",
        "Dalibor Dvorsky",
        "Jonatan Berggren"
      ],
      line4: [
        "Alexey Toropchenko",
        "Pius Suter",
        "Oskar Sundqvist"
      ]
    },
    defense: {
      line1: [
        "Philip Broberg",
        "Logan Mailloux"
      ],
      line2: [
        "Theo Lindstein",
        "Colton Parayko"
      ],
      line3: [
        "Cam Fowler",
        "Tyler Tucker"
      ]
    },
    goalies: {
      line1: [
        "Joel Hofer",
        "Jordan Binnington"
      ]
    }
  },
  "tampa-bay-lightning": {
    forwards: {
      line1: [
        "Brandon Hagel",
        "Anthony Cirelli",
        "Nikita Kucherov"
      ],
      line2: [
        "Jake Guentzel",
        "Brayden Point",
        "Gage Goncalves"
      ],
      line3: [
        "Nick Paul",
        "Yanni Gourde",
        "Oliver Bjorkstrand"
      ],
      line4: [
        "Corey Perry",
        "Conor Geekie",
        "Scott Sabourin"
      ]
    },
    defense: {
      line1: [
        "J.J. Moser",
        "Declan Carlile"
      ],
      line2: [
        "Ryan McDonagh",
        "Erik Cernak"
      ],
      line3: [
        "Charle-Edouard D'Astous",
        "Emil Lilleberg"
      ]
    },
    goalies: {
      line1: [
        "Andrei Vasilevskiy",
        "Jonas Johansson"
      ]
    }
  },
  "toronto-maple-leafs": {
    forwards: {
      line1: [
        "Matias Maccelli",
        "John Tavares",
        "William Nylander"
      ],
      line2: [
        "Easton Cowan",
        "Max Domi",
        "Matthew Knies"
      ],
      line3: [
        "Steven Lorentz",
        "Luke Haymes",
        "Nicholas Robertson"
      ],
      line4: [
        "Michael Pezzetta",
        "Jacob Quillan",
        "Calle Jarnkrok"
      ]
    },
    defense: {
      line1: [
        "William Villeneuve",
        "Oliver Ekman-Larsson"
      ],
      line2: [
        "Morgan Rielly",
        "Troy Stecher"
      ],
      line3: [
        "Simon Benoit",
        "Jake McCabe"
      ]
    },
    goalies: {
      line1: [
        "Joseph Woll",
        "Artur Akhtyamov"
      ]
    }
  },
  "utah-mammoth": {
    forwards: {
      line1: [
        "Clayton Keller",
        "Nick Schmaltz",
        "Lawson Crouse"
      ],
      line2: [
        "Kailer Yamamoto",
        "Logan Cooley",
        "Dylan Guenther"
      ],
      line3: [
        "JJ Peterka",
        "Alex Kerfoot",
        "Michael Carcone"
      ],
      line4: [
        "Brandon Tanev",
        "Kevin Stenlund",
        "Liam O'Brien"
      ]
    },
    defense: {
      line1: [
        "Mikhail Sergachev",
        "MacKenzie Weegar"
      ],
      line2: [
        "Nate Schmidt",
        "Dmitri Simashev"
      ],
      line3: [
        "Ian Cole",
        "Sean Durzi"
      ]
    },
    goalies: {
      line1: [
        "Vitek Vanecek",
        "Karel Vejmelka"
      ]
    }
  },
  "vancouver-canucks": {
    forwards: {
      line1: [
        "Liam Ohgren",
        "Teddy Blueger",
        "Brock Boeser"
      ],
      line2: [
        "Drew O'Connor",
        "Marco Rossi",
        "Linus Karlsson"
      ],
      line3: [
        "Jake DeBrusk",
        "Elias Pettersson",
        "Nils Hoglander"
      ],
      line4: [
        "Curtis Douglas",
        "Ty Mueller",
        "Aatu Raty"
      ]
    },
    defense: {
      line1: [
        "Zeev Buium",
        "Filip Hronek"
      ],
      line2: [
        "Marcus Pettersson",
        "Tom Willander"
      ],
      line3: [
        "Elias Nils Pettersson",
        "Kirill Kudryavtsev"
      ]
    },
    goalies: {
      line1: [
        "Nikita Tolopilo",
        "Kevin Lankinen"
      ]
    }
  },
  "vegas-golden-knights": {
    forwards: {
      line1: [
        "Mitch Marner",
        "Jack Eichel",
        "Mark Stone"
      ],
      line2: [
        "Ivan Barbashev",
        "Brett Howden",
        "Pavel Dorofeyev"
      ],
      line3: [
        "Brandon Saad",
        "Tomas Hertl",
        "Colton Sissons"
      ],
      line4: [
        "Cole Smith",
        "Nic Dowd",
        "Keegan Kolesar"
      ]
    },
    defense: {
      line1: [
        "Brayden McNabb",
        "Shea Theodore"
      ],
      line2: [
        "Noah Hanifin",
        "Rasmus Andersson"
      ],
      line3: [
        "Jeremy Lauzon",
        "Kaedan Korczak"
      ]
    },
    goalies: {
      line1: [
        "Carter Hart",
        "Adin Hill"
      ]
    }
  },
  "washington-capitals": {
    forwards: {
      line1: [
        "Alex Ovechkin",
        "Dylan Strome",
        "Anthony Beauvillier"
      ],
      line2: [
        "Aliaksei Protas",
        "Ilya Protas",
        "Tom Wilson"
      ],
      line3: [
        "Connor McMichael",
        "Pierre-Luc Dubois",
        "Ryan Leonard"
      ],
      line4: [
        "Brandon Duhaime",
        "Justin Sourdif",
        "Ivan Miroshnichenko"
      ]
    },
    defense: {
      line1: [
        "Martin Fehervary",
        "Timothy Liljegren"
      ],
      line2: [
        "Jakob Chychrun",
        "Trevor van Riemsdyk"
      ],
      line3: [
        "Cole Hutson",
        "Matt Roy"
      ]
    },
    goalies: {
      line1: [
        "Logan Thompson",
        "Mitchell Gibson"
      ]
    }
  },
  "winnipeg-jets": {
    forwards: {
      line1: [
        "Kyle Connor",
        "Mark Scheifele",
        "Alex Iafallo"
      ],
      line2: [
        "Cole Perfetti",
        "Adam Lowry",
        "Gabriel Vilardi"
      ],
      line3: [
        "Nino Niederreiter",
        "Vladislav Namestnikov",
        "Brad Lambert"
      ],
      line4: [
        "Cole Koepke",
        "Jonathan Toews",
        "Isak Rosen"
      ]
    },
    defense: {
      line1: [
        "Josh Morrissey",
        "Dylan DeMelo"
      ],
      line2: [
        "Dylan Samberg",
        "Neal Pionk"
      ],
      line3: [
        "Haydn Fleury",
        "Jacob Bryson"
      ]
    },
    goalies: {
      line1: [
        "Connor Hellebuyck",
        "Eric Comrie"
      ]
    }
  }
}
;

export default lineup;